export default "__VITE_ASSET__B$izBWkH__"